import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MedicationFinderService } from '@services/medication-finder.service';
import { MedicationSavings } from '@interfaces/medication-savings.interface';
import { SubscriptionManager } from '@zelis/platform-ui-components';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-medication-finder-savings',
  templateUrl: './medication-finder-savings.component.html',
  styleUrls: ['./medication-finder-savings.component.scss'],
})
export class MedicationFinderSavingsComponent implements OnInit, OnDestroy {
  @Input() public showHeader?: boolean = true;
  @Input() public contentSpacing?: boolean = true;
  @Input() public fullscreen?: boolean = false;

  public variant: string = 'elevated';
  public emphasis: string = 'high';
  public iconName: string = 'dls-illustration-medication';
  public totalSavings: number;
  public title: string;
  public cardText: string;
  public buttonText: string = 'medication_finder_savings_button_text';
  public isRewardable: boolean;

  private subscriptions: SubscriptionManager = new SubscriptionManager();

  constructor(private medicationFinderService: MedicationFinderService) {}

  ngOnInit(): void {
    this.subscriptions.add(this.getMemberSavings());
  }

  ngOnDestroy(): void {
    this.subscriptions.destroy();
  }

  public goToRxSS(): void {
    this.medicationFinderService.redirectToRxss();
  }

  private getMemberSavings(): Subscription {
    return this.medicationFinderService
      .getSavings()
      .subscribe((savings: MedicationSavings) => {
        this.totalSavings = savings ? savings.total_member_savings : 0;
        this.isRewardable = savings && !!savings.is_rewardable;
        this.determineTitleAndText();
      });
  }

  private determineTitleAndText(): void {
    if (this.totalSavings > 0 && this.isRewardable) {
      this.title = 'medication_finder_savings_and_rewards_card_title';
      this.cardText = 'medication_finder_savings_and_rewards_card_text';
    } else if (this.totalSavings > 0) {
      this.title = 'medication_finder_savings_card_title';
      this.cardText = 'medication_finder_savings_card_text';
    } else if (this.isRewardable) {
      this.title = 'medication_finder_rewards_card_title';
      this.cardText = 'medication_finder_rewards_card_text';
      this.buttonText = 'medication_finder_rewards_button_text';
    } else {
      this.title = 'medication_finder_savings_card_title_no_savings';
      this.cardText = 'medication_finder_savings_card_text';
    }
  }
}
